import { SelectItem } from 'primeng/primeng';
import { GLAdjustment } from '../../../models/glAdjustment.model';
import { GLAdjustmentStage } from '../../../models/glAdjustmentStage.model';
import { GLPolicy } from '../../../models/glPolicy.model';

export class EventSearchGLPolicyHelper {

  constructor() {
  }

  public toSelectItems(glPolicies: GLPolicy[]): SelectItem[] {
    let selectItems: SelectItem[] = []
    glPolicies.forEach((policy: GLPolicy) => {
      let policySelection = {
        label: policy.GLPolicyDescription,
        value: policy,
      }
      selectItems.push(policySelection)
    })
    return selectItems
  }

  public toGLAdjustments(glAdjustmentsStage: GLAdjustmentStage[]) {
    let glAdjustments: GLAdjustment[] = []

    glAdjustmentsStage.forEach((adjustmentStage: GLAdjustmentStage) => {
      let glAdjustment = new GLAdjustment(adjustmentStage.glCode, adjustmentStage.glPolicyCode, adjustmentStage.amount)
      glAdjustments.push(glAdjustment)
    })

    return glAdjustments
  }
}



// WEBPACK FOOTER //
// ./src/app/components/event-search/helpers/event-search.glPolicyHelper.ts